export const colors = {
  white: '#ffffff',
  black: '#121212',

  gray100: '#BEBEBE',
  gray200: '#585858',
  gray300: '#272727',
  gray400: '#141414',

  red100: '#F3734B',
  red200: '#AF5335',

  yellow100: '#FFD25E',

  neonShadow: '#20BF72',

  // neon100: '#A7FE89',
  // neon200: '#7BBC65',
  neon100: '#4FD08F',
  neon200: '#43B17A',
} as const;
